module.exports = __webpack_public_path__ + "media/images/countrysquared/pr-e101f0cebdb68f2a8dc6373efa6121f1.svg";